import React from 'react'

// Components
import Button from 'components/Button'
import Modal from 'components/Modal'
import { ModalInjectedProps } from 'containers/ModalManager'

// Types
import { useAcceptLicenseRedemptionMutation } from 'gqlTypes'

interface RedeemLicenseConfirmationModalProps extends ModalInjectedProps {
  redemptionToken: string
  workspaceName: string
  workspaceId: string
}

export const RedeemLicenseConfirmationModal: React.FC<RedeemLicenseConfirmationModalProps> = props => {
  const { hideModal, redemptionToken, workspaceName, workspaceId } = props

  const [confirmRedemption, { loading }] = useAcceptLicenseRedemptionMutation({
    variables: { redemptionToken, workspaceId },
    onCompleted: () => {
      hideModal()
    },
    onError: 'show-toast',
  })

  return (
    <Modal
      title="Are you sure you want to redeem this license key?"
      onCancel={hideModal}>
      <Modal.Body>
        This will deactivate the license and apply credit to{' '}
        <b>{workspaceName}</b>. This action cannot be undone.
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={hideModal}>Cancel</Button>
        <Button
          variant="negative"
          onClick={() => confirmRedemption()}
          loading={loading}>
          Redeem license key
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
